import { Close } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import {
	CSSProperties,
	FC,
	MouseEventHandler,
	PropsWithChildren,
	useEffect,
	useState,
} from 'react';
import useEditionPanelStyles from './EditionPanel.styles';

interface Props {
	bodyStyle?: CSSProperties;
	loading?: boolean;
	onCancel?: MouseEventHandler<HTMLButtonElement>;
	onClose(): void;
	onSave?: MouseEventHandler<HTMLButtonElement>;
	showActions?: boolean;
	subTitle?: string;
	title: string;
}

const EditionPanel: FC<PropsWithChildren<Props>> = ({
	bodyStyle = { padding: 24 },
	loading,
	children,
	onCancel,
	onClose,
	onSave,
	showActions,
	subTitle,
	title,
}) => {
	// States
	const [otherHeight, setOtherHeight] = useState<number>(0);

	// Hooks
	const classes = useEditionPanelStyles();

	// Effects
	useEffect(() => {
		function keydownListener(e: globalThis.KeyboardEvent): void {
			if (!document.getElementById('creation-panel')) {
				if (e.key === 'Escape') {
					onClose();
				}
			}
		}

		document.body.addEventListener('keydown', keydownListener);

		return () => {
			document.body.removeEventListener('keydown', keydownListener);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		let height = document.getElementById('edition-panel-header')?.offsetHeight ?? 0;

		if (showActions) {
			height += document.getElementById('edition-panel-actions')?.offsetHeight ?? 0;
		}

		setOtherHeight(height);
	}, [showActions]);

	return (
		<div className={classes.root} id="edition-panel">
			<div className={classes.header} id="edition-panel-header">
				<div className={classes.titleContainer}>
					<Typography
						color="#003C82"
						fontFamily="Montserrat"
						fontSize={18}
						fontWeight="bold"
						id="edition-panel-header-title"
					>
						{title}
						{subTitle && (
							<Typography
								className={classes.subTitle}
								color="#686868"
								component="span"
								fontFamily="Montserrat"
								fontSize={14}
								fontWeight="medium"
							>
								{subTitle}
							</Typography>
						)}
					</Typography>
				</div>
				<button className={classes.closeButton} onClick={onClose}>
					<Close />
				</button>
			</div>
			<div
				className={classes.body}
				id="edition-panel-body"
				style={{
					...bodyStyle,
					maxHeight: `calc(100% - ${otherHeight}px)`,
				}}
			>
				{children}
			</div>
			{!document.getElementById('creation-panel') && showActions && (
				<div className={classes.actions} id="edition-panel-actions">
					<Button
						disabled={loading}
						color="secondary"
						onClick={onCancel}
						size="large"
						variant="outlined"
					>
						Cancelar
					</Button>
					<Button disabled={loading} onClick={onSave} size="large" variant="contained">
						Guardar
					</Button>
				</div>
			)}
		</div>
	);
};

export default EditionPanel;
